import { render, staticRenderFns } from "./BannerCard.vue?vue&type=template&id=2d513560&scoped=true&"
import script from "./BannerCard.vue?vue&type=script&lang=js&"
export * from "./BannerCard.vue?vue&type=script&lang=js&"
import style0 from "./BannerCard.vue?vue&type=style&index=0&id=2d513560&scoped=true&lang=css&"
import style1 from "./BannerCard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d513560",
  null
  
)

export default component.exports